import {
  FetchLifestyleDetectionsCacheKey,
  FetchLifestyleDetectionsGqlQuery,
  LifestyleDetectionDetectRequestID
} from '../../lifestyleDetectionsTypes';
import { ID } from '../../../../types';

import { useCacheIndexQuery } from '../../../common/reactQuery/hooks/useCacheIndexQuery';

import { LifestyleDetectionsPermissions } from '../../lifestyleDetectionsConstants';
import { IndexQueryResponse } from '../../../common/reactQuery/hooks/useIndexQuery';

interface LifestyleDetectionsExtraType {
  detectRequestId: LifestyleDetectionDetectRequestID;
}

interface CacheLifestyleDetectionsOptions<NodeType> {
  cacheKey: FetchLifestyleDetectionsCacheKey;
  query: FetchLifestyleDetectionsGqlQuery;
  options?: {
    cacheTime?: number;
    staleTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    withoutPrefetch?: true;
    keepPreviousData?: boolean;
    onSuccess?: (
      data: IndexQueryResponse<
        NodeType,
        undefined,
        undefined,
        LifestyleDetectionsExtraType
      >
    ) => void;
  };
  imageUrl?: string;
  imageId?: ID;
  lifestyleId?: ID;
}

const scope = 'lifestyleDetectionsByImageUrl';

function useCacheLifestyleDetections<LifestyleDetectionItemType>({
  cacheKey,
  options = {},
  query,
  imageUrl,
  imageId,
  lifestyleId
}: CacheLifestyleDetectionsOptions<LifestyleDetectionItemType>) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isLoading,
    isPlaceholderData
  } = useCacheIndexQuery<
    LifestyleDetectionItemType,
    undefined,
    undefined,
    LifestyleDetectionsExtraType
  >({
    action:
      LifestyleDetectionsPermissions.READ_LIFESTYLE_DETECTIONS_INDEX_ES_QUERY,
    cacheKey,
    cacheQuery: query,
    options,
    query,
    scope,
    defaultApi: 'cache_api',
    additionalParams: {
      imageUrl,
      imageId,
      lifestyleId
    }
  });

  return {
    lifestyleDetectionsData: data,
    lifestyleDetections: items,
    lifestyleDetectionsError: itemsError,
    lifestyleDetectionsTotalCount: itemsTotalCount,
    lifestyleDetectionsFetched: isFetched,
    lifestyleDetectionsLoading: isLoading,
    lifestyleDetectionsIsPlaceholderData: isPlaceholderData,
    lifestyleDetectionsDetectRequestId: data?.[scope]?.detectRequestId
  };
}

export default useCacheLifestyleDetections;
